import { CONFIG } from '@frontend/config';
import { useAuth } from '@frontend/features/auth/hooks/useAuth';
import { useGetSettingsByAgencyId } from '@frontend/features/agencies/queries';
import { useConnectorCapabilities } from './queries';
import { searchAvailability, SEARCH_NAVIGATION, type SearchAvailability } from './searchNavigation';

export function useSearchAvailability() {
  const { ability, myProfile } = useAuth();
  const canUseServices = SEARCH_NAVIGATION.some((entry) => entry.vertical && ability?.can('view', entry.permission));
  const settings = useGetSettingsByAgencyId({ id: canUseServices ? String(CONFIG.AGENCY_ID) : undefined });
  const connectors = useConnectorCapabilities(
    canUseServices && settings.data?.RUTERO_ENABLED === 'true' && !settings.isError,
  );
  return (vertical: string): SearchAvailability => {
    if (!myProfile) return 'loading';
    if (!canUseServices) return 'unavailable';
    return searchAvailability(vertical, settings, connectors);
  };
}
